import React from 'react';
import { formatDistanceToNow, format as formatDate, differenceInHours, differenceInDays, isThisYear, parseISO } from 'date-fns';
import { ko } from 'date-fns/locale';
/**
 * 시간 표시 컴포넌트
 * UTC 시간을 로컬 시간으로 변환하여 다양한 형식으로 표시합니다.
 */ export var TimeDisplay = function(param) {
    var time = param.time, _param_format = param.format, format = _param_format === void 0 ? 'smart' : _param_format, _param_size = param.size, size = _param_size === void 0 ? 'md' : _param_size, _param_className = param.className, className = _param_className === void 0 ? '' : _param_className;
    // 사이즈별 텍스트 크기 매핑
    var textSizeMap = {
        'xs': 'text-xs',
        'sm': 'text-sm',
        'md': 'text-base',
        'lg': 'text-lg',
        'xl': 'text-xl'
    };
    // 날짜 객체로 변환 (문자열이 주어진 경우)
    var getDateObject = function(timeInput) {
        if (typeof timeInput === 'string') {
            // ISO 형식 문자열인지 확인 (YYYY-MM-DDTHH:mm:ss 형식)
            if (timeInput.includes('T') && (timeInput.includes('Z') || timeInput.includes('+'))) {
                try {
                    return parseISO(timeInput);
                } catch (error) {
                    console.error('ISO 시간 문자열 파싱 오류:', error);
                    return new Date(timeInput);
                }
            }
            return new Date(timeInput);
        }
        return timeInput;
    };
    // 시간을 포맷팅하는 함수
    var formatTime = function(timeInput) {
        if (!timeInput) return '';
        try {
            var date = getDateObject(timeInput);
            // 유효하지 않은 날짜인 경우
            if (isNaN(date.getTime())) {
                console.error('유효하지 않은 날짜:', timeInput);
                return '';
            }
            // 상대적 시간 표시 (n분 전, n시간 전 등)
            if (format === 'relative') {
                return formatDistanceToNow(date, {
                    addSuffix: true,
                    locale: ko
                });
            }
            // 스마트 표시 (최근 시간은 상대적으로, 오래된 시간은 절대적으로)
            if (format === 'smart') {
                var now = new Date();
                var hoursDiff = differenceInHours(now, date);
                var daysDiff = differenceInDays(now, date);
                // 24시간 이내
                if (hoursDiff < 24) {
                    return formatDistanceToNow(date, {
                        addSuffix: true,
                        locale: ko
                    });
                } else if (daysDiff < 7) {
                    return "".concat(daysDiff, "일 전");
                } else if (isThisYear(date)) {
                    return formatDate(date, 'M월 d일', {
                        locale: ko
                    });
                } else {
                    return formatDate(date, 'yyyy년 M월 d일', {
                        locale: ko
                    });
                }
            }
            // 절대적 시간 표시 (연/월/일)
            if (format === 'absolute') {
                return formatDate(date, 'yyyy년 M월 d일', {
                    locale: ko
                });
            }
            // 상세 시간 표시 (연/월/일 시:분)
            if (format === 'detailed') {
                return formatDate(date, 'yyyy년 M월 d일 HH:mm', {
                    locale: ko
                });
            }
            // 기본값은 스마트 표시와 동일
            var now1 = new Date();
            var hoursDiff1 = differenceInHours(now1, date);
            if (hoursDiff1 < 24) {
                return formatDistanceToNow(date, {
                    addSuffix: true,
                    locale: ko
                });
            } else {
                return formatDate(date, 'yyyy년 M월 d일', {
                    locale: ko
                });
            }
        } catch (error) {
            console.error('시간 포맷팅 오류:', error);
            return typeof timeInput === 'string' ? timeInput : timeInput.toString();
        }
    };
    return /*#__PURE__*/ React.createElement("span", {
        className: "".concat(textSizeMap[size], " ").concat(className)
    }, formatTime(time));
};
export default TimeDisplay;
